export enum AuthzAction {
  VIEW = "VIEW",
  EDIT = "EDIT",
}
